
import SignUpPage from '../pages/auth/sign-up/page'
import SignInPage from '../pages/auth/sign-in/page'
import AdminSignInPage from '../pages/admin/auth/sign-in/page'
import AdminDashboardPage from '../pages/admin/dashboard/page'
import React from 'react';
import type { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import MarketplacePage from '../pages/marketplace/page';
import ShopPage from '../pages/shop/page';
import ProductPage from '../pages/product/page';
import SellPage from '../pages/sell/page';
import SellerDashboardPage from '../pages/seller-dashboard/page';
import ProfilePage from '../pages/profile/page';
import SellerProfilePage from '../pages/seller/page';
import MessagesPage from '../pages/messages/page';
import CheckoutPage from '../pages/checkout/page';
import ContactPage from '../pages/contact/page';
import WalletPage from '../pages/wallet/page';
import OrderDetailsPage from '../pages/order-details/page';
import CartPage from '../pages/cart/page';
import PendingVerificationPage from '../pages/pending-verification/page';
import BuyerOrdersPage from '../pages/buyer-orders/page';
import SellerOrdersPage from '../pages/seller-orders/page';
import PricingPage from '../pages/pricing/page';
import NotFoundPage from '../pages/NotFound';
import BuyerDashboardPage from '../pages/buyer-dashboard/page';
import PrivacyPage from '../pages/privacy/page';
import TermsPage from '../pages/terms/page';
import AcceptableUsePage from '../pages/acceptable-use/page';
import RefundPolicyPage from '../pages/refund/page';
import VerifyEmailPage from '../pages/action/verify-email/page';
import ResetPasswordPage from '../pages/action/reset-password/page';
import ForgotPasswordPage from '../pages/auth/forgot-password/page';
import EmailVerificationPage from '../pages/auth/email-verification/page';
import SupportPage from '../pages/support/page';
import ReportPage from '../pages/report/page';
import NotificationsPage from '../pages/notifications/page';
import AdminSupportPage from '../pages/admin/support/page';
import ReferralsPage from '../pages/referrals/page';
import TicketPurchasePage from '../pages/tickets/page';
import HostelsPage from '../pages/hostels/page';
import TutorialsPage from '../pages/tutorials/page';
import VerifyResetCodePage from '../pages/auth/verify-reset-code/page';
import ResetPasswordCodeNewPage from '../pages/auth/reset-password-code/new/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <MarketplacePage />
  },
  {
    path: '/home',
    element: <HomePage />
  },
  {
    path: '/marketplace',
    element: <MarketplacePage />
  },
  {
    path: '/hostels',
    element: <HostelsPage />
  },
  {
    path: '/shop',
    element: <ShopPage />
  },
  {
    path: '/product/:id',
    element: <ProductPage />
  },
  {
    path: '/listing/:id',
    element: <ProductPage />
  },
  {
    path: '/seller/:sellerId',
    element: <SellerProfilePage />
  },
  {
    path: '/sell',
    element: <SellPage />
  },
  {
    path: '/seller-dashboard',
    element: <SellerDashboardPage />
  },
  {
    path: '/buyer-dashboard',
    element: <BuyerDashboardPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/messages',
    element: <MessagesPage />
  },
  {
    path: '/notifications',
    element: <NotificationsPage />
  },
  {
    path: '/checkout',
    element: <CheckoutPage />
  },
  {
    path: '/cart',
    element: <CartPage />
  },
  {
    path: '/tutorials',
    element: <TutorialsPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/support',
    element: <SupportPage />
  },
  {
    path: '/report',
    element: <ReportPage />
  },
  {
    path: '/wallet',
    element: <WalletPage />
  },
  {
    path: '/orders',
    element: <BuyerOrdersPage />
  },
  {
    path: '/seller-orders',
    element: <SellerOrdersPage />
  },
  {
    path: '/order/:orderId',
    element: <OrderDetailsPage />
  },
  {
    path: '/referrals',
    element: <ReferralsPage />
  },
  {
    path: '/auth/sign-up',
    element: <SignUpPage />
  },
  {
    path: '/auth/sign-in',
    element: <SignInPage />
  },
  {
    path: '/auth/email-verification',
    element: <EmailVerificationPage />
  },
  {
    path: '/pending-verification',
    element: <PendingVerificationPage />
  },
  {
    path: '/admin/sign-in',
    element: <AdminSignInPage />
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />
  },
  {
    path: '/admin/support',
    element: <AdminSupportPage />
  },
  {
    path: '/pricing',
    element: <PricingPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '/acceptable-use',
    element: <AcceptableUsePage />
  },
  {
    path: '/refund-policy',
    element: <RefundPolicyPage />
  },
  {
    path: '/action/verify-email',
    element: <VerifyEmailPage />
  },
  {
    path: '/action/reset-password',
    element: <ResetPasswordPage />
  },
  {
    path: '/auth/forgot-password',
    element: <ForgotPasswordPage />
  },
  {
    path: '/auth/verify-reset-code',
    element: <VerifyResetCodePage />
  },
  {
    path: '/auth/reset-password-code/new',
    element: <ResetPasswordCodeNewPage />
  },
  {
    path: '/tickets/:linkId',
    element: <TicketPurchasePage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

// Admin-only build mode: expose only admin routes on admin deploy
const isAdminOnly = import.meta.env.VITE_ADMIN_ONLY === 'true' || import.meta.env.VITE_ADMIN_ONLY === true;
const exportedRoutes: RouteObject[] = isAdminOnly
  ? routes
      .filter(r => typeof r.path === 'string' && (r.path === '/' || r.path?.startsWith('/admin') || r.path === '*'))
      .map(r => (r.path === '/' ? { ...r, element: <AdminSignInPage /> } : r))
  : routes;

export default exportedRoutes;
